import { Helmet } from 'react-helmet';
import { EditRestaurant } from 'src/components/EditRestaurant';

const EditRestaurantPage = () => (
  <>
    <Helmet>
      <title> Edit Restaurant</title>
    </Helmet>

    <EditRestaurant />
  </>
);

export default EditRestaurantPage;
